import AndroidIcon from '@mui/icons-material/AndroidRounded';
import AppleIcon from '@mui/icons-material/Apple';
import WebIcon from '@mui/icons-material/LanguageRounded';
import { Chip, chipClasses } from '@mui/material';
import type { ReactElement } from 'react';
import { ApplicationPlatform } from '../../model/types';

export const APPLICATION_PLATFORM_LABEL_MAP: Record<
  ApplicationPlatform,
  string
> = {
  [ApplicationPlatform.web]: 'Web',
  [ApplicationPlatform.android]: 'Google Play',
  [ApplicationPlatform.ios]: 'App Store',
};

export const APPLICATION_PLATFORM_ICON_MAP: Record<
  ApplicationPlatform,
  ReactElement
> = {
  [ApplicationPlatform.web]: <WebIcon />,
  [ApplicationPlatform.android]: <AndroidIcon />,
  [ApplicationPlatform.ios]: <AppleIcon />,
};

interface Props {
  applicationPlatform: ApplicationPlatform;
}

export function ApplicationPlatformChip({ applicationPlatform }: Props) {
  return (
    <Chip
      sx={{ borderRadius: 2, [`& .${chipClasses.label}`]: { pr: 1 } }}
      avatar={APPLICATION_PLATFORM_ICON_MAP[applicationPlatform]}
      label={APPLICATION_PLATFORM_LABEL_MAP[applicationPlatform]}
    />
  );
}
